import React from 'react'


const BriefCall = () => {

  return (


      <div className='BriefCall' style={{width:'100%', textAlign:'center',
      backgroundImage: 'linear-gradient(30deg, rgba(181,239,250,1) 33%, rgba(54,179,210,1) 100%)'}}>
      <a target="_blank" rel="noopener noreferrer" href="https://docs.google.com/forms/d/e/1FAIpQLSdANuJU_Y9eE5CYJcBx6JIwMOj6i4KxKQ7lHydKXE89vRfVMQ/viewform">
        <div style={{paddingTop:'30px',paddingBottom:'50px'}}>
          <div className='column' >
            <p className='title' style={{color:'white',fontSize:'29px'}}>
              <b>Wypełnij nasz brief</b>
            </p>
            <p className='subtitle' style={{color:'white',fontSize:'18px',fontWeight:'600'}}>
              A w ciągu 24h otrzymasz wycenę naszych usług.
            </p>
              <span className='btnblog' style={{fontSize:'14px',fontWeight:'800'}} > Wypełnij brief&nbsp; &nbsp;
              <img width="15px" height="22px" style={{verticalAlign:'middle', marginRight:'5px'}}   alt="brief" src='/img/angle-right.svg'/>
              </span>

            <br />

          </div>

        </div>
        </a>
      </div>



  )
}

export default BriefCall
